import { CommonBG, Rule } from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  InstructionColor,
  InstructionLogo,
  InstructionText,
} from '../../../../lib/instructionSettings';
import { deleteData, hasData } from '../../../localStorage/LocalStorageManager';
import Dialog from '../../../uiElements/Dialog';

interface RuleInstrctionProps {
  //stageId: number;
  ruleImgSrc?: string;
  onStart?: () => void;
  onBack?: () => void;
}

const Program3Rule: React.FC<RuleInstrctionProps> = () => {
  const navigate = useNavigate();
  const { trainingId } = useParams<'trainingId'>();

  const text = InstructionText[3];

  const [isShowModal, setIsShowModal] = React.useState<boolean>(false);
  return (
    <CommonBG>
      <Rule
        title={text.title}
        mission={text.mission}
        description={text.description}
        video={text.video}
        onStart={() => {
          if (!trainingId) {
            return;
          }
          if (hasData('program3', trainingId)) {
            setIsShowModal(true);
          } else {
            navigate(`/${trainingId}/program3/countdown/1`);
          }
        }}
        onBack={() => navigate(`/${trainingId}/stages`)}
        color={InstructionColor}
        logo={InstructionLogo}
      />
      <Dialog
        message={
          '前回の進捗があります。続きから始めますか？\n新規に始める場合は「新規に始める」を選択してください。'
        }
        isShow={isShowModal}
        cancelText={'新規に始める'}
        onCancel={() => {
          if (!trainingId) {
            return;
          }
          deleteData('program3', trainingId);
          navigate(`/${trainingId}/program3/countdown/1`);
        }}
        onConfirm={() => {
          const currentPage =
            localStorage.getItem('currentpage-program3') ?? 'countdown/1';
          navigate(`/${trainingId}/program3/${currentPage}`);
        }}
      />
    </CommonBG>
  );
};

export default Program3Rule;
